import { Icon } from '@/icons/Icon'

type VideoControlsProps = {
  playing: boolean
  setPlaying: (playing: boolean) => void
  muted: boolean
  setMuted: (muted: boolean) => void
  setModal: (modal: boolean) => void
  customClick?: () => void
}

export default function VideoControls({
  playing,
  setPlaying,
  muted,
  setMuted,
  setModal,
  customClick,
}: VideoControlsProps) {
  const iconClass = 'flex h-10 w-10 cursor-pointer items-center justify-center'

  const handleClick = (type: 'play' | 'mute' | 'modal') => {
    if (customClick) {
      customClick()
      return
    }

    if (type === 'play') setPlaying(!playing)
    if (type === 'mute') setMuted(!muted)
    if (type === 'modal') setModal(true)
  }

  return (
    <div className="absolute bottom-3 right-5 z-20 flex gap-2 text-white sm:bottom-12 sm:right-12">
      <button
        type="button"
        aria-label="Play Video"
        onClick={() => handleClick('play')}
        className={iconClass}
      >
        {playing ? <Icon name="media-pause" /> : <Icon name="media-play" />}
      </button>
      {/* <button type="button" aria-lable="Mute Video" onClick={() => handleClick('mute')} className={iconClass}>
        {muted ? <Icon name="volume-off" /> : <Icon name="volume-up" />}
      </button> */}
      <button
        type="button"
        aria-label="Open Modal"
        onClick={() => handleClick('modal')}
        className={iconClass}
      >
        <Icon name="tv" />
      </button>
    </div>
  )
}
